import { createApp } from './main-hg';

import { initDataDog } from './datadog-client-setup';

initDataDog();

//#region Normal Vue 3 app setup
const { app, router, store } = createApp();

const initialState = window.__INITIAL_STATE__;
if (initialState) {
  store.replaceState(initialState);
}

router.isReady().then(() => {
  app.mount('#app');
});
//#endregion
